import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.chaiscript = bracketIndenting()
